<template>
<div id="data-analysis">
    <c-body class="c-body">
        <div slot="before-header">
            <Tabs :value="currentTab" @on-click="onClickTab">
                <TabPane label="账号" name="accountAnalysis"></TabPane>
                <TabPane label="国家" name="countryAnalysis"></TabPane>
                <TabPane label="包名" name="bundleAnalysis"></TabPane>
                <TabPane label="广告位" name="adsenseAnalysis"></TabPane>
            </Tabs>
        </div>
        <div slot="section">
            <router-view></router-view>
        </div>
    </c-body>
</div>
</template>
<script>
import cBody from '@/components/commons/cBody.vue';
export default {
    name: 'DataAnalysis',
    components: {
        cBody
    },
    computed: {
        currentTab() {
            return this.$route.name;
        }
    },
    methods: {
        /*
		 * @description 点击tab，切换导航
		 * @param link:string 路由地址
		 */
        onClickTab(link) {
            // 无效排序返回
            this.$router.push({ name: link });
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/view/DataAnalysis/DataAnalysis.vue